<template>
  <modal
    :title="$t(title)"
    :appendToBody="true"
    :top="'12vh'"
    :visible.sync="isShowDialog"
  >
    <div class="configNetPage">
      <!-- 基本信息 -->
      <ul class="base-info">
        <li v-for="item in baseMsg" :key="item.key">
          <span class="label">{{ $t(item.text) }}：</span>
          <span class="value">
            <template
              v-if="item.key === 'config_status' || item.key === 'device_type'"
            >
              <span>{{ changeTextFn(item.key, cmdObj[item.key]) }}</span>
            </template>
            <template v-else-if="item.key === 'step'">
              <span
                v-show="
                  cmdObj[item.key] && typeof cmdObj[item.key] === 'string'
                "
              >
                <span>{{ stepFn(cmdObj[item.key]) }}</span>
              </span>
            </template>
            <template v-else-if="item.isBool">
              <span v-if="cmdObj['config_status'] !== 2">{{
                objFn1(cmdObj[item.key], item.key)
              }}</span>
              <span style="color:red">{{ objFn2(cmdObj[item.key], item.key) }}</span>
            </template>
            <span v-else> {{ item.key === 'time_zone' ? $t(shiquArrayConvert(cmdObj[item.key])) : cmdObj[item.key] }}</span>
          </span>
        </li>
      </ul>
    </div>
  </modal>
</template>

<script>
import { configStep, gasType, configStatusConvert, shiquArrayConvert } from '@/utils/convert'

export default {
  props: {
    title: { type: String, default: '' },
    isShow: { type: Boolean, default: false },
    cmdObj: { type: Object, default: () => ({}) },
    sensorWay: { type: String, default: '' }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
    shiquArrayConvert: () => shiquArrayConvert,
  },
  watch: {
    cmdObj (newVal) {
      this.baseMsg = [
        {
          key: 'url',
          text: 'public.belong'
        },
        {
          key: 'gas_code',
          text: 'integration.gas_code'
        },
        {
          key: 'config_status',
          text: 'device.config_status'
        },
        {
          key: 'carrierName',
          text: 'public.carrier'
        },
        {
          key: 'device_type',
          text: 'integration.gas_type'
        },
        {
          key: 'description',
          text: 'public.table_desc'
        }
      ]
      // 去除监测点
      if (
        this.$attrs.sensorWay === 'unknown' ||
        this.$attrs.sensorWay === 'unbind'
      ) {
        this.baseMsg.splice(3, 1)
      }
      if (newVal.config_status === '') {
        this.baseMsg = this.baseMsg.filter(item => item.key !== 'config_status')
      }
      const publicArray = [
        {
          key: 'cmd',
          text: 'public.command'
        },
        {
          key: 'step',
          text: 'integration.configuration_steps'
        }
      ]
      if (newVal.type === 'app') {
        if(newVal.device_type === 6){
          this.baseMsg.push(
            {
              key: 'collectInterval',
              text: 'device.sample_interval',
              isBool: true
            },
            {
              key: 'normal_report_interval',
              text: 'device.normal_reporting_interval',
              isBool: true
            },
            {
              key: 'abnormal_report_interval',
              text: 'device.abnormal_reporting_interval',
              isBool: true
            },
            {
              key: 'time_zone',
              text: 'device.time_zone',
              isBool: true
            },
            ...publicArray
          )
        }else{
          this.baseMsg.push(
            {
              key: 'collectInterval',
              text: 'device.sample_interval',
              isBool: true
            },
            {
              key: 'alarm_threshold',
              text: 'integration.alarm_threshold',
              isBool: true
            },
            ...publicArray
          )
        }

      }
    }
  },
  data () {
    return {
      baseMsg: []
    }
  },
  methods: {
    changeTextFn (key, value) {
      if (key === 'device_type') {
        return gasType[value] && this.$t(gasType[value].title)
      } else {
        // return value === 0
        //   ? $t('device.wait_config')
        //   : value === 1
        //     ? $t('device.configured')
        //     : $t('device.configured')
        return this.$t(configStatusConvert(value).title)
      }
    },
    objFn1 (obj, key) {
      if(key === 'time_zone'){
        return obj ? this.$t(shiquArrayConvert(obj.current)) + '-->' : ''
      }else{
        return obj ? obj.current + '-->' : ''
      }
    },
    objFn2 (obj, key) {
      if(key === 'time_zone'){
        return obj ? this.$t(shiquArrayConvert(obj.modify)) : ''
      }else{
        return obj ? obj.modify : ''
      }
    },
    stepFn (value) {
      return configStep[value] && this.$t(configStep[value].title)
    }
  }
}
</script>

<style lang="scss" scoped>
.configNetPage {
  .base-info {
    display: grid;
    grid-template-columns: max-content 1fr;
    column-gap: 10px;
    padding: 10px 20px;
    max-height: 500px;
    overflow: auto;

    li {
      display: contents;
    }

    .label {
      text-align: right;
      line-height: 32px;
      color: #606266;
      font-size: 14px;
    }

    .value {
      line-height: 32px;
      color: #606266;
      font-size: 14px;
      text-align: left;
    }
  }
}
</style>
